import React from 'react';
import { observer } from 'mobx-react-lite';
import { roundTimeStore } from '../../../store/roundTimeStore';
import { roundInfoStore, useTranslation } from '@pascal/pascal-core';
import { gameStore } from '../../../store/gameStore';

export const BetInfo = observer(() => {
  const t = useTranslation();

  return (
    <div className='roulette-mobile-bets-ins'>
      <p className='roulette-mobile-bets-text'>
        {gameStore.isNotification
          ? t('NO_MORE_BETS')
          : gameStore.isBetsClosed
          ? t('WAIT_FOR_NEXT_ROUND')
          : t('PLACE_YOUR_BETS')}
      </p>
      {roundTimeStore.time !== null && (
        <div
          className='roulette-mobile-bg-ins'
          style={{
            width: `${((roundTimeStore.time - 1) * 100) / (roundInfoStore.duration - 1)}%`,
          }}
        />
      )}
      {/*<div className="roulette-mobile-bg-ins" style={{width:"70%"}}/>*/}
    </div>
  );
});
